import { redirectDocument } from 'react-router-dom';
import Paths from './paths';
import { genRouteMap } from '@/scripts/router';

export const routeMap = genRouteMap({
  [Paths.BASE]: {
    loader: async ({ request }) => {
      const url = new URL(request.url);
      if (url.pathname === '/') {
        return redirectDocument(Paths.MAIN);
      }
      return null;
    },
  },
  [Paths.MAIN]: {},
});
